import React from 'react';
import { StyledLeafletItem } from '../styles';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Zoom } from 'swiper';
import { TLeafletItem } from 'src/types/types';
import { E_LINK_KIND } from 'src/utils/enum';
import { useNavigate } from 'react-router-dom';
import { bridgeOpenBrowser } from 'src/utils/bridge';
import { IS_LEAFLET_TYPE } from 'src/utils/constants';
import { appStoreMove } from 'src/utils/leaflet';
import { getInnerLinkData } from 'src/utils/utility';

type TProps = {
  leafletData: TLeafletItem;
  categorySwiper?: SwiperCore;
  setContentSwiper: (swiperCore: SwiperCore) => void;
  setSelectedTab: (i: number) => void;
  setGaEvent: (title: string) => void;
};

/**
 * @name 전단 이미지
 */
function LeafletItem(props: TProps): React.ReactElement {
  const navigate = useNavigate();

  const handleChangeSwiper = (e: SwiperCore) => {
    props.setContentSwiper(e);
    props.categorySwiper?.slideTo(e.activeIndex);
    props.setSelectedTab(e.activeIndex);
  };

  // 연결 링크 이동
  const handleClickBtnLink = leaflet => {
    // 연결없음 클릭방지
    if (leaflet.link_type === E_LINK_KIND.NONE) return;
    // GA 수집
    props.setGaEvent(`연결링크(${leaflet.img_nm})`);
    if (leaflet.link_type === E_LINK_KIND.INSIDE) {
      if (IS_LEAFLET_TYPE) {
        // 앱전단 : 모든 루트 가능
        const innerLinkData = getInnerLinkData(leaflet.link_url);
        navigate(innerLinkData.url, { replace: innerLinkData.replace });
      } else {
        // 웹전단 : 메인, /leaflet pathname에 쿼리스트링 있을 경우만 내부이동
        if (
          leaflet.link_url === '/' ||
          leaflet.link_url.includes('/leaflet?')
        ) {
          navigate(leaflet.link_url);
        } else if (leaflet.link_url.includes('?leaflet_id=')) {
          navigate(`/leaflet${leaflet.link_url}`);
        } else {
          const url =
            process.env.REACT_APP_GO_URL +
            leaflet.link_url +
            '&hfrom=APP&rst1=J';
          appStoreMove(url);
        }
      }
    } else if (leaflet.link_type === E_LINK_KIND.OUTSIDE) {
      bridgeOpenBrowser(leaflet.link_url);
    } else return;
  };

  return (
    <StyledLeafletItem>
      <Swiper
        slidesPerView={1}
        onSwiper={e => props.setContentSwiper(e)}
        onSlideChange={e => handleChangeSwiper(e)}
        a11y={{
          prevSlideMessage: '이전 슬라이드',
          nextSlideMessage: '다음 슬라이드',
          slideLabelMessage:
            '총 {{slidesLength}}장의 슬라이드 중 {{index}}번 슬라이드 입니다.',
        }}
        keyboard={{ enabled: true }}
        zoom={{ maxRatio: 5 }}
        modules={[Zoom]}
      >
        {props.leafletData.leaflet_img_list.map((item, i) => {
          const a11yId = 'detail_img_' + i;
          return (
            <SwiperSlide key={i}>
              <div className="swiper-zoom-container">
                <img
                  src={`${item.img_url}`}
                  alt={`전단 ${i + 1}면`}
                  aria-describedby={a11yId}
                  onClick={() => handleClickBtnLink(item)}
                />
                <div className="blind" id={a11yId}>
                  {item.img_desc}
                </div>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </StyledLeafletItem>
  );
}

export default LeafletItem;
